'use strict';

filterCategoryItem.$inject = ["common"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.filterCategoryItem = filterCategoryItem;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function filterCategoryItem(common) {
    var clazz = function FilterCategoryItem() {
        var defaults = {
            id: '',
            name: '',
            isSelected: false,
            isParent: true,
            level: 0
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource, selectedIds, level, formatNameToPascalCase) {
        var item = new clazz();
        item.id = resource.id;
        if (formatNameToPascalCase) {
            item.name = common.toPascalCase(resource.name);
        } else {
            item.name = resource.name;
        }
        item.isSelected = resource.isSelected ? true : selectedIds ? selectedIds.indexOf(resource.id) >= 0 : false;
        item.isParent = false;
        item.level = level || 1;
        return item;
    };

    clazz.createParent = function (resource, level) {
        var item = new clazz();
        item.id = resource.id;
        item.name = resource.name;
        item.isSelected = true;
        item.isParent = true;
        item.level = level || 1;
        return item;
    };

    return clazz;
}


//////////////////
// WEBPACK FOOTER
// ./common/models/filterCategoryItemModel.js
// module id = 748
// module chunks = 0